import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import { PayerRow, PayerStatus } from "@wingspanhq/wingspan-api-sdk";
import { selectorSearchRowName } from "../../../../shared/selectors/selectorSearchRowName";

/**
 * Columns for the v3 `searchPayerRows`-backed clients table, rendered off the
 * denormalized `PayerRow`. `PayerRow` is leaner than the payee row — no TIN /
 * location / requirements-status rollup — so this stays close to the original
 * clients columns (Name / Contact / Status) plus the Engagements the row now
 * carries. See V3_MIGRATION_TRACKER.md (payer-rows §).
 */

export const getColumns = (): WSTableColumn<PayerRow>[] => [
  {
    config: {
      gridTemplateSizeMin: "0",
      gridTemplateSizeMax: "1.5fr",
      header: { text: "Name" }
    },
    renderFunction: rowItem => {
      const name = selectorSearchRowName(rowItem.data) || "--";
      return <WSTableCell avatar={{ type: "text", text: name }} text={name} />;
    }
  },
  {
    config: {
      gridTemplateSizeMin: "0",
      gridTemplateSizeMax: "1fr",
      header: { text: "Contact" },
      hideOnScreens: ["XS"]
    },
    renderFunction: rowItem => <WSTableCell text={rowItem.data.email || "--"} />
  },
  {
    config: {
      gridTemplateSizeMin: "0",
      gridTemplateSizeMax: "1fr",
      header: { text: "Engagements" },
      hideOnScreens: ["XS"]
    },
    renderFunction: rowItem => {
      const names = (rowItem.data.engagements ?? [])
        .map(e => e.engagementName)
        .filter(Boolean);
      return (
        <WSTableCell
          text={names[0] ?? "--"}
          secondaryText={
            names.length > 1 ? `+${names.length - 1} more` : undefined
          }
        />
      );
    }
  },
  {
    config: {
      gridTemplateSizeMin: "0",
      gridTemplateSizeMax: "0.6fr",
      header: { text: "Status" }
    },
    renderFunction: rowItem => {
      const isActive = rowItem.data.status === PayerStatus.ACTIVATED;
      return (
        <WSTableCell
          pill={{
            icon: true,
            theme: isActive ? "success" : "neutral",
            text: isActive ? "Active" : "Inactive"
          }}
        />
      );
    }
  }
];
